export default {
  id: 'roles/no-role',
  title: 'No role',
  description: 'Has been added to the organization with zero access.',
};
